import { RootState } from "../../store/root-reducer";

const getState = (state: RootState) => state.institutionDetails;

export const getInstitutionDetailsError = (state: RootState) => getState(state).error;
export const getInstitutionDetails = (state: RootState) => getState(state).institutionDetails;
export const getInstitutionDetailsIsFetching = (state: RootState) => getState(state).isFetching;

export const getInstitutionPhoneNumber = (state: RootState) => getState(state).institutionDetails?.phoneNumber;
